module.exports = __webpack_public_path__ + "img/right1.61b0d878.png";